import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Item } from '../models/item';
import { Observable } from 'rxjs';
import { IQueryResult } from '../../../base/interfaces/IQueryResult';

@Injectable({
  providedIn: 'root'
})
export class ItemService  extends BaseService<Item>{

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string        
  ) { 
    super(http,rootUrl,'TimeTracking/Item');
  }
  getStatus(): Observable<IQueryResult<Item>> {
    return this.http.get<IQueryResult<Item>>(`${this.rootUrl}/${this.endpoint}/status`);
  }
}
